module.exports = __webpack_public_path__ + "img/40_bohle.4a3b975d.jpeg";